export function shortenText(text, maxLength = 120) {
    if (!text || text.length <= maxLength) return text;
    return (
        text
            .replace(/<\/?[^>]+(>|$)/g, '')
            .slice(0, maxLength)
            .trim()
            .split(/\s+/)
            .slice(0, -1)
            .join(' ') + '...'
    );
}
